<template>
    <v-card class="pb-4">
        <template v-if="documents.length">
            <v-list-item
                v-for="(doc, index) in documents"
                :key="doc.id"
                :class="{'mb-5': index === documents.length - 1}"
                :data-cy="`document-${index}`"
                @click="downloadDocument(doc)"
            >
                <template v-slot:prepend>
                    <v-tooltip location="top">
                        <template v-slot:activator="{props}">
                            <v-icon size="small" :color="doc.visibleForAll ? 'success' : ''" v-bind="props">
                                {{ doc.visibleForAll ? 'mdi-eye' : 'mdi-eye-remove-outline' }}
                            </v-icon>
                        </template>
                        <span>
                            {{ `${$t('visible_for')} ${doc.visibleForAll ? $t('for_all') : $t('for_to1_only')}` }}
                        </span>
                    </v-tooltip>
                    <v-icon size="small" color="blue-darken-1">mdi-download</v-icon>
                </template>
                <v-list-item-title>
                    <div class="d-flex flex-column text-wrap">
                        <a>{{ doc.name }}</a>
                        <span class="text-caption text--secondary">
                            {{ getServiceName(doc.processId) }}
                        </span>
                    </div>
                </v-list-item-title>
                <template v-slot:append>
                    <v-list-item-action>
                        <v-btn
                            size="small"
                            icon="mdi-trash-can-outline"
                            data-cy="remove-document"
                            variant="text"
                            @click.stop="makeInactive(doc)"
                        />
                    </v-list-item-action>
                </template>
            </v-list-item>
        </template>
        <v-list-item v-else class="mb-5">{{ $t('no_uploaded_documents') }}</v-list-item>
        <v-list-item>
            <slot />
        </v-list-item>
    </v-card>
</template>
<script setup lang="ts">
    import {downloadData} from '~/utils/helpers'

    const props = defineProps<{
        documents: any
        orderServices: any
    }>()

    const emit = defineEmits<{
        (e: 'removeDocument'): void
    }>()

    const services = ref([])

    const app = useNuxtApp()
    const {t} = useI18n()

    onMounted(async () => {
        const itemsByServices = props.orderServices.map(e => ({
            name: e.serviceName,
            value: e.processId,
            status: e.status,
        }))
        services.value = [{name: t('reservation'), value: null, status: null}, ...itemsByServices]
    })

    const getServiceName = processId => {
        return services.value.find(s => s.value === processId)?.name
    }

    const downloadDocument = async doc => {
        const rs = await app.$api.documents.get({id: doc.id})
        const decodedData = atob(rs[0].encodedData)
        const data = new Uint8Array(decodedData.split('').map(char => char.charCodeAt(0)))
        downloadData(data, doc.name)
    }

    const makeInactive = async doc => {
        try {
            await app.$api.documents.put(doc.id, {})
            emit('removeDocument')
        } catch (e) {
            app.$toast.error(t('error_message.something_went_wrong'))
        }
    }
</script>
